import { Directive, ElementRef, HostListener, Input } from '@angular/core';

const FOCUSABLE_SELECTOR = 'input, select, textarea, button, [tabindex]';

@Directive({
  selector: '[appRequireBeforeAdvance]',
  standalone: true
})
export class RequireBeforeAdvanceDirective {
  @Input() appRequireBeforeAdvanceValid: (() => boolean) | null = null;

  constructor(private el: ElementRef<HTMLInputElement>) { }

  private isValid(): boolean {
    if (this.appRequireBeforeAdvanceValid) {
      return this.appRequireBeforeAdvanceValid();
    }
    const value = this.el.nativeElement.value;
    return value != null && value.toString().trim() !== '';
  }

  private focusNext() {
    const container = this.el.nativeElement.closest('form') ?? document.body;
    const candidates = Array.from(container.querySelectorAll<HTMLElement>(FOCUSABLE_SELECTOR))
      .filter(elem =>
        !(elem as HTMLInputElement | HTMLButtonElement | HTMLSelectElement).disabled &&
        elem.tabIndex !== -1 &&
        elem.offsetParent !== null
      );

    const currentIndex = candidates.indexOf(this.el.nativeElement);
    if (currentIndex > -1 && currentIndex < candidates.length - 1) {
      candidates[currentIndex + 1].focus();
    }
  }

  @HostListener('keydown', ['$event'])
  onKeydown(event: KeyboardEvent) {
    const isTabForward = event.key === 'Tab' && !event.shiftKey;
    const isEnter = event.key === 'Enter';
    if (!isTabForward && !isEnter) return;

    if (!this.isValid()) {
      event.preventDefault();
      return;
    }

    if (isEnter) {
      event.preventDefault();
      this.focusNext();
    }
    // Tab forward with a value present: let the browser handle the native tab order.
  }
}
